<script setup lang="ts">
import { computed } from "vue";
import { useGlobalStore } from "@/stores";
import PageHeading from "@/components/general/PageHeading/PageHeading.vue";
import JourneyLayout from "@/components/layout/JourneyLayout/JourneyLayout.vue";

const global = useGlobalStore();

const msg = computed(() => {
    return (
        global.systemMaintenanceMessage ||
        "Our site is currently undergoing scheduled maintenance. We apologise for any inconvenience and appreciate your patience."
    );
});
</script>

<template>
    <div id="maintenance-page" class="container-fluid content-padding">
        <JourneyLayout>
            <template #main>
                <PageHeading> We'll be back soon! </PageHeading>
                <div class="maintenance-content">
                    <p class="maintenance-message">
                        {{ msg }}
                    </p>
                </div>
            </template>
        </JourneyLayout>
    </div>
</template>

<style scoped>
.maintenance-content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
}

.maintenance-message {
    font-size: 1rem;
    font-weight: 400;
    color: var(--text-title-color);
    line-height: 1.5rem;
    margin: 0;
}
</style>
